import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosResponse } from 'axios';

import { RootState } from '../..';
import constants from '../../../constants';
import { Item } from '../types';
import getContext from './get-context';

const getData = createAsyncThunk('api/get-data', async (_, thunkAPI) => {
  const state = thunkAPI.getState() as RootState;

  await thunkAPI.dispatch(getContext());

  // update the axios response to match the customer data format.
  let response: AxiosResponse<Item[]>;

  try {
    response = await axios.get(
      `${state.api.customerServiceUrl}${constants.endpoints.get.hierarchySummary}`,
      {
        withCredentials: true, // Ensure credentials are sent with the request.
      },
    );
  } catch (e: unknown) {
    return thunkAPI.rejectWithValue(e);
  }

  // return data from the response.
  return response.data;
});

export default getData;
